import {
  toAppliedInferences,
  type ApReportInference,
  type AppliedInference,
} from '@/context/services/report_inferences/utils';
import { useCallback, useEffect, useMemo, useState } from 'react';

export type InferenceOverrides = Partial<ApReportInference>;

export type UseInferenceBaselineReturn = {
  baseline: ApReportInference[];
  appliedInferences: AppliedInference[];
  applyBaselineOverrides: (applied: InferenceOverrides) => void;
};

const NO_OVERRIDES: InferenceOverrides = {};

export const useInferenceBaseline = (
  fetchedInferences: ApReportInference[]
): UseInferenceBaselineReturn => {
  const [overrides, setOverrides] = useState<InferenceOverrides>(NO_OVERRIDES);

  useEffect(() => {
    setOverrides(NO_OVERRIDES);
  }, [fetchedInferences]);

  const applyBaselineOverrides = useCallback((applied: InferenceOverrides) => {
    setOverrides((current) => ({ ...current, ...applied }));
  }, []);

  const latestInference = fetchedInferences[0];
  const baseline = useMemo(
    () => [{ ...latestInference, ...overrides }],
    [latestInference, overrides]
  );

  const appliedInferences = useMemo(
    () => toAppliedInferences(overrides),
    [overrides]
  );

  return { baseline, appliedInferences, applyBaselineOverrides };
};
